import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["remaining"]
  static values = { startAt: String }

  connect() {
    this.render()
    this.interval = window.setInterval(() => this.render(), 1000)
    this.visibilityChange = () => this.render()
    document.addEventListener("visibilitychange", this.visibilityChange)
  }

  disconnect() {
    window.clearInterval(this.interval)
    document.removeEventListener("visibilitychange", this.visibilityChange)
  }

  render() {
    if (!this.hasRemainingTarget) return

    const startAt = new Date(this.startAtValue)
    if (Number.isNaN(startAt.getTime())) return

    this.remainingTarget.textContent = this.wordingFor(startAt.getTime() - Date.now())
  }

  wordingFor(milliseconds) {
    const seconds = Math.trunc(milliseconds / 1000)
    if (seconds <= 0) return this.marriedWording(-seconds)
    if (seconds >= 7 * 24 * 60 * 60) return `${Math.floor(seconds / 86400)} days to go`

    return `${this.durationWording(seconds)} to go`
  }

  marriedWording(seconds) {
    const days = Math.floor(seconds / 86400)
    if (days === 0) return "Married today"

    return `Married for ${new Intl.NumberFormat("en").format(days)} ${days === 1 ? "day" : "days"}`
  }

  durationWording(seconds) {
    const days = Math.floor(seconds / 86400)
    const hours = Math.floor((seconds % 86400) / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const remainingSeconds = seconds % 60
    const clock = [hours, minutes, remainingSeconds].map((value) => String(value).padStart(2, "0")).join(":")

    return days > 0 ? `${days} ${days === 1 ? "day" : "days"} ${clock}` : clock
  }
}
